class PetForm extends HTMLElement {
  /**
   * Constructor of the component. Calls the _init method.
   *
   * @return {void}
   */
  constructor() {
    super();

    this._init();
  }

  /**
   * Initializes the component by selecting necessary elements and adding event listeners to them.
   *
   * @private
   */
  _init() {
    this.form = this.querySelector("form.pet-form__form");
    this.pictureInput = document.querySelector("input#picture");
    this.dataInput = document.querySelector('input#pet_data__field');
    this.formSubmit = this.querySelector("#submit");
    this.productFormSubmit = document.querySelector(
      "form.form button.product-form__submit"
    );

    console.log("DATA INPUT", this.dataInput)

    this.form.addEventListener("submit", this._handleSubmit.bind(this));
    this.form.addEventListener("change", this._validate.bind(this));
    this.pictureInput.addEventListener("change", this._validate.bind(this));
    this.pictureInput.addEventListener(
      "change",
      this._onPictureChange.bind(this)
    );
  }

  /**
   * Handles a change event on the picture input. If the user has selected a new file, it updates the label to display the file name.
   *
   * @private
   * @param {Event} event - The change event.
   */
  _onPictureChange(event) {
    const file = event.target.files[0];

    const label = document.querySelector(".pet-form__label.file .file_label");

    if (!file) return;

    label.textContent = file.name;
  }

  /**
   * Validates the form and checks if the user has selected a picture. If all inputs are valid and a picture has been selected, it enables the submit button.
   *
   * @private
   */
  _validate() {
    const inputs = this.form.querySelectorAll("input, select, textarea");
    const isValid = [...inputs].every((input) => input.checkValidity());
    const hasPicture = this.pictureInput.checkValidity();

    if (isValid && hasPicture) {
      this.formSubmit.disabled = false;
    }
  }

  /**
   * Handles the form submission by preventing the default action, collecting form data,
   * triggering a click on the product form submit button, and updating the cart after a delay.
   *
   * @private
   * @param {Event} event - The form submit event.
   */

  _handleSubmit(event) {
    event.preventDefault();
    const formData = new FormData(event.target);
    let cartNote = "";

    for (const pair of formData.entries()) {
      cartNote += `${pair[0]}: ${pair[1]} \n`;
    }

    formData.append("note", cartNote);
    this.dataInput.value = cartNote;

    this.productFormSubmit.click();

    setTimeout(() => {
      this._updateCart(formData);
    }, 1000);
  }

  /**
   * Updates the cart with the form data.
   * @param {FormData} formData - The form data to send to the server.
   * @private
   */
  _updateCart(formData) {
    for (const pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        this.form.reset();
      });
  }
}

customElements.define("pet-form", PetForm);
